import jQuery from "jquery";
import header from "../common/header.js";
import scrollReveal from "../page-secondary/scroll-reveal.js";
import footer from "../common/footer.js";
import global from "../page-secondary/global.js";
import popup from "../popup.js";
import reviewsSlider from "../../sliders/reviews-slider.js";
import relatedSlider from "../../sliders/related-slider.js";
import blog from "../page-secondary/blog.js"
import tableOfContent from "../../module/blog-new/table-of-content-new.js";
import initHeaderAnchors from "../../module/blog-new/title-anchors.js";
window.$ = window.jQuery = jQuery;

jQuery(document).ready(function ($) {
  header();
  global();
  blog();
  scrollReveal();
  popup();
  tableOfContent();
  initHeaderAnchors();
  reviewsSlider();
  relatedSlider();
  footer();
});
